// extracted by mini-css-extract-plugin
export default {"form":"Form_form__gS8ya","add":"Form_add__WP9KF","input":"Form_input__SxWED"};